import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import runtime from 'serviceworker-webpack-plugin/lib/runtime';

import App from './App';
import configureStore from './store/configureStore';
import './index.css';

if (window.location.origin.includes('https://app-stage.ava.me')) {
  LogRocket.init('xyqwjx/ava-scribe');
  setupLogRocketReact(LogRocket);
}

const setupServiceWorker = async () => {
  try {
    const registration = await runtime.register();
    if (registration) {
      registration.update();
    }
  } catch (e) {
    Sentry.captureException('Could not register the Service Worker', e);
  }
};

if ('serviceWorker' in navigator) {
  setupServiceWorker();
}

const isProd =
  window.location.href.indexOf('app.avascribe.com') > -1 ||
  window.location.href.indexOf('app.ava.me') > -1 ||
  window.location.href.indexOf('web.ava.me') > -1;

const isLocal = window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('127.0.0.1') > -1;

// See https://docs.sentry.io/clients/javascript/config/ for details.
Sentry.init({
  dsn: 'https://598382256bd44dc7b175357bac4bc464@sentry.io/1303073',
  integrations: [new Integrations.BrowserTracing()],
  environment: isProd ? 'production' : 'playground',
  release: process.env.HASH_COMMIT,
  enabled: !isLocal,
  ignoreErrors: ['connection appears to be offline'],
});

const store = configureStore();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
